export default "__VITE_ASSET__cb5d29ed__"